import { render } from "./DatenschutzPage.vue?vue&type=template&id=1dfe5edc"
import script from "./DatenschutzPage.vue?vue&type=script&lang=js"
export * from "./DatenschutzPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__